/**
 * Takes two lists of ranges, each range represented by a start and end number
 * Returns a list of ranges representing the first ranges minus the last ranges
 */
export function rangesMinusRanges(ra, rb) {
  const rangesMinusRange = (ra, rb) => {
    const result: { start: string; end: string }[] = [];
    ra.forEach((a) => {
      if (rb.end <= a.start || rb.start >= a.end) {
        result.push(a);
      } else if (rb.start > a.start && rb.end < a.end) {
        result.push({ start: a.start, end: rb.start });
        result.push({ start: rb.end, end: a.end });
      } else if (rb.start <= a.start && rb.end > a.start && rb.end < a.end) {
        result.push({
          start: rb.end,
          end: a.end,
        });
      } else if (rb.start > a.start && rb.start < a.end && rb.end >= a.end) {
        result.push({
          start: a.start,
          end: rb.start,
        });
      }
    });
    return result;
  };
  rb.forEach((b) => {
    ra = rangesMinusRange(ra, b);
  });
  return ra;
}
